/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { FuturesBrokerResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class FuturesBrokers<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name OptionsFuturesBrokers
   * @request OPTIONS:/futuresBrokers/{id}
   */
  optionsFuturesBrokers = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/futuresBrokers/${id}`,
      method: 'OPTIONS',
      ...params,
    });
  /**
   * No description
   *
   * @name GetFuturesBrokers
   * @request GET:/futuresBrokers
   * @secure
   */
  getFuturesBrokers = (params: RequestParams = {}) =>
    this.request<FuturesBrokerResponse, any>({
      path: `/futuresBrokers`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsFuturesBrokers2
   * @request OPTIONS:/futuresBrokers
   * @originalName optionsFuturesBrokers
   * @duplicate
   */
  optionsFuturesBrokers2 = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/futuresBrokers`,
      method: 'OPTIONS',
      ...params,
    });
}
